import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /mail group. See http/payment.ts for conventions. */
export const ResendParams = Schema.Struct({
    siteId: SiteId,
    mailId: Schema.String
});
export const ResendResponse = Schema.Struct({ message: Schema.String });
//# sourceMappingURL=mail.js.map